import { apiClient, getCookie } from './api';
import $ from 'jquery';
import Handlebars from 'handlebars/runtime';
import { showLoginModal } from '../login';

// Register Handlebars helper for equality comparison
Handlebars.registerHelper('eq', function(a, b) {
    return a === b;
});

/**
 * Vote on a bitmap
 * @param {number} bitmapId - The ID of the bitmap to vote on
 * @param {number} value - Vote value (1 for like, -1 for dislike, 0 to remove)
 * @param {function} onSuccess - Success callback
 * @param {function} onError - Error callback
 */
export async function voteBitmap(bitmapId, value, onSuccess, onError) {
    const endpoint = `/api/bitmaps/vote/${bitmapId}/`;
    const data = { value: value };
    
    await apiClient(endpoint, {
        method: 'POST',
        body: JSON.stringify(data),
        notJSON: false
    }, onSuccess, onError);
}

/**
 * Update vote UI
 * @param {number} bitmapId - The ID of the bitmap
 * @param {object} scores - Vote scores object {positive, negative, total}
 * @param {number} userVote - User's current vote (1, -1, or null)
 */
export function updateVoteUI(bitmapId, scores, userVote) {
    // Update like button and count
    const $likeButton = $(`#like_bitmap_${bitmapId}`);
    const $positiveCount = $(`#positive_score_${bitmapId}`);
    
    if (userVote === 1) {
        $likeButton.addClass('selected');
    } else {
        $likeButton.removeClass('selected');
    }
    
    $positiveCount.text(`+${scores.positive}`);
    
    // Update dislike button and count
    const $dislikeButton = $(`#unlike_bitmap_${bitmapId}`);
    const $negativeCount = $(`#negative_score_${bitmapId}`);
    
    if (userVote === -1) {
        $dislikeButton.addClass('selected');
    } else {
        $dislikeButton.removeClass('selected');
    }
    
    $negativeCount.text(scores.negative > 0 ? `-${scores.negative}` : '0');
}

/**
 * Initialize vote handlers
 */
export function initializeVoteHandlers() {
    // Like button handler
    $(document).on('click', '.icon_like', function(e) {
        e.preventDefault();
        
        // Check if user is authenticated
        const accessToken = getCookie('access_token');
        if (!accessToken) {
            showLoginModal();
            return;
        }
        
        const $button = $(this);
        const bitmapId = $button.data('bitmap-id');
        const isSelected = $button.hasClass('selected');
        
        // If already liked, remove vote (0), otherwise like (1)
        const voteValue = isSelected ? 0 : 1;
        
        voteBitmap(bitmapId, voteValue,
            (response) => {
                updateVoteUI(bitmapId, response.scores, response.user_vote);
            },
            (error) => {
                console.error('Vote failed:', error);
                if (error.detail && error.detail.includes('Authentication')) {
                    showLoginModal();
                } else {
                    alert('Failed to vote. Please try again.');
                }
            }
        );
    });
    
    // Dislike button handler
    $(document).on('click', '.icon_unlike', function(e) {
        e.preventDefault();
        
        // Check if user is authenticated
        const accessToken = getCookie('access_token');
        if (!accessToken) {
            showLoginModal();
            return;
        }
        
        const $button = $(this);
        const bitmapId = $button.data('bitmap-id');
        const isSelected = $button.hasClass('selected');
        
        // If already disliked, remove vote (0), otherwise dislike (-1)
        const voteValue = isSelected ? 0 : -1;
        
        voteBitmap(bitmapId, voteValue,
            (response) => {
                updateVoteUI(bitmapId, response.scores, response.user_vote);
            },
            (error) => {
                console.error('Vote failed:', error);
                if (error.detail && error.detail.includes('Authentication')) {
                    showLoginModal();
                } else {
                    alert('Failed to vote. Please try again.');
                }
            }
        );
    });
}